export const ID_MODULE_MAP = {
    1: 'Freeform Editor',
    2: 'Video'
  };
  

  